<template>
  <div id="app">
    <keep-alive :include="keepAlive">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
export default {
  name: 'App',
  computed: {
    keepAlive() {
      console.log(this.$store.state.app.keepAlive);
      return this.$store.state.app.keepAlive;
    },
  },
  beforeCreate() {},
};
</script>
